import { debounce } from 'lodash-es'
import { onMounted, ref, watch } from 'vue'

// This composable ensures search inputs stay synced with their state,
// avoiding desync issues in Vuetify 3, especially when debounced or losing focus.
export function useSearch (searchSetter: Function, debounceDelay: number, searchInitialValue = '') {
  // Vuetify 3 can't keep the internal state of SearchTextField and an external state in sync,
  // so a local buffer state is used.
  const searchQuery = ref(searchInitialValue)
  let debouncedSearchQueryUpdate = () => {}

  onMounted(() => {
    debouncedSearchQueryUpdate = debounce(() => {
      searchSetter(searchQuery.value)
    }, debounceDelay)
  })

  watch(searchQuery, (newValue) => {
    // All new values are debounced but clears are instant
    if (newValue !== '') {
      debouncedSearchQueryUpdate()
    } else {
      searchSetter('')
    }
  })

  return {
    searchQuery,
  }
}
